import { render, staticRenderFns } from "./PaymentProfile.vue?vue&type=template&id=ebf19e7a"
import script from "./PaymentProfile.vue?vue&type=script&lang=js"
export * from "./PaymentProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports